<template>
  <button ref="button" class="ripple-button" :class="{ 'hover': activeHover }" @mousemove="rippleMove"
    @mouseenter="rippleIn" @mouseleave="rippleOut">
    <span class="relative text">
      <slot></slot>
    </span>
    <span ref="ripple" class="ripple"></span>
  </button>
</template>

<script setup>
import { ref } from 'vue';


const button = ref(null);
const ripple = ref(null);
const activeHover = ref(false);

const rippleIn = (event) => {
  activeHover.value = true;
  rippleMove(event);
};

const rippleOut = (event) => {
  activeHover.value = false;
  rippleMove(event);
};

const rippleMove = (event) => {
  
  try{
    const buttonElement = event.currentTarget;
    
    const rect = buttonElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;


    const rippleElement = ripple.value;
    const rippleheight = rippleElement.clientHeight;
    const ripplewidth = rippleElement.clientWidth;

    rippleElement.style.left = `${x - ripplewidth / 2}px`;
    rippleElement.style.top = `${y - rippleheight / 2}px`;
    rippleElement.classList.add('animate-ripple');
  } catch (error) {
    // Element destroyed
  }
};


onMounted(() => {
  const rippleElement = ripple.value;
  rippleElement.style.width = `${button.value.clientWidth}px`;
  rippleElement.style.height = `${button.value.clientWidth}px`;
});

</script>

<style scoped>
@reference "../../assets/css/main.css";
button.ripple-button {
  border: 2pt solid black;
  @apply px-4 py-1 lg:py-2 rounded-md text-lg;
  font-variation-settings: 'wght' 500, 'wdth' 110, 'slnt' 0;
  
}

button.ripple-button.small{
  @apply text-base;
}

.text{
  z-index: 9;
}

.ripple-button {
  @apply relative overflow-hidden text-black border-black outline-none;

  transition: color .5s, border-color .5s;

  cursor: pointer;
}

.ripple-button.brown {

  @apply bg-gravaadarkbrown text-white border-gravaadarkbrown;

}

.ripple-button.black {

  @apply bg-gravaablack text-white border-gravaablack;

}

.ripple-button.lightbrown {

  @apply bg-gravaalightbrown text-white border-gravaalightbrown;

}

.ripple-button.white {
  @apply border-white text-white;
  background: #00000042;

}


.ripple-button.blue {

  @apply bg-gravaablue text-white border-gravaablue;
  transition: color .5s, border-color .5s, background-color .5s;
}

.ripple-button.hover.blue {
  @apply text-black border-black;
  background-color: rgba(255, 255, 255, .0);
}

.ripple-button.hover {
  @apply text-white border-gravaablue;
}

.ripple-button .ripple {
  @apply bg-gravaablue absolute rounded-full;
  transition: transform .5s;
  transform: scale(0);

}

.ripple-button.tobrown.hover {
  @apply text-white border-gravaabrown;
}

.ripple-button.tobrown .ripple {
  @apply bg-gravaabrown;
}

.ripple-button.blue .ripple {
  @apply bg-white;
  transition: opacity 1s, transform 0.5s;
}

.ripple-button.hover .ripple {
  opacity: 1;
  transform: scale(2.5);
}

.ripple-button.hover.blue .ripple {
  opacity: .5;
}
</style>